import { Typography, Stack } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import sampleRadar from "../assets/sample radar.PNG";

const RadarReportInstructions = ({ languageId, hasMaths }) => {
  return (
    <Box sx={{ margin: 3 }}>
      <Typography variant="h6" component="div">
        {languageId === 2 ? "解讀「你的成就」蜘蛛圖：" : "Interpreting the 'Your Achievement' Spider Chart:"}
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        <img
          src={sampleRadar}
          alt="showing an example graph of the reading component"
          style={{ width: "30%", height: "30%" }}
        />
        <Box sx={{ pl: "11vw" }}>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `解讀「你的成就」蜘蛛圖：` : `
              The 'Your Achievement' chart depicts your child's relative
              performance across several problem solving behaviours:
            `}
          </Typography>
          <ul>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? "閱讀速度與分析" : "Reading Speed & Analysis"}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? hasMaths ? "數學能力" : "思考技能" : hasMaths ? "Mathematical Ability" : "Thinking Skills"}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? "方法與策略" : "Strategy & Method"}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? "常識與推理" : "General Knowledge & Reasoning"}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? "速度與精準度" : "Speed & Accuracy"}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? "毅力" : "Perseverance"}
              </Typography>
            </li>
          </ul>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              蜘蛛圖中心點距離越遠，表示你的孩子在解決該特定問題方面的表現就越好，優於其他學生。
            ` : `
              The further the distance from the centre of the spider diagram means
              the better the performance of your child in that particular problem
              solving behaviour compared to other students.
            `}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default RadarReportInstructions;
